import { render, staticRenderFns } from "./PanelClientHistory.vue?vue&type=template&id=7c9d4173&scoped=true&"
import script from "./PanelClientHistory.vue?vue&type=script&lang=js&"
export * from "./PanelClientHistory.vue?vue&type=script&lang=js&"
import style0 from "./PanelClientHistory.vue?vue&type=style&index=0&id=7c9d4173&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d4173",
  null
  
)

export default component.exports